import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import messages from "components/messagesDescription";
import { injectIntl, intlShape } from "react-intl";
import { compose, withHandlers, withState } from "recompose";
import { Card, CardSection, Toolbar, ToolbarSection, Button, Loader } from "cxa-components";
import EmployeeDelegationTable from "./EmployeeDelegationTable";
import { RouteMap } from "components/common/navigation/routeMap";
import { getDelegationList, revokeDelegation } from "actions/delegationActions";
import { RevokeDelegationDialog } from "./widgets";

const enhanceDelegationContainer = compose(
  injectIntl,
  connect(
    state => ({
      delegation: state.delegation,
    }),
    {
      getDelegationList,
      revokeDelegation,
    }
  ),
  withState("isModalOpen", "toggleModal", false),
  withState("modalEmployeeDelegated", "setModalEmployeeDelegation", {}),
  withHandlers({
    openModal: props => () => props.toggleModal(true),
    closeModal: props => () => props.toggleModal(false),
  })
);

class DelegationContainer extends Component {
  componentDidMount() {
    this.props.getDelegationList();
  }

  navigateAddDelegation() {
    this.props.push(RouteMap.SearchDelegation);
  }

  onOpenModal = data => {
    const { setModalEmployeeDelegation, toggleModal } = this.props;

    setModalEmployeeDelegation(data);
    toggleModal(true);
  };

  onRevokeDelegation = data => {
    const { toggleModal, revokeDelegation, getDelegationList } = this.props;

    revokeDelegation(data).then(() => getDelegationList());
    toggleModal(false);
  };

  render() {
    const {
      intl,
      delegation: { isfetching, isfetched, employees },
      isModalOpen,
      closeModal,
      modalEmployeeDelegated,
    } = this.props;

    const action = { revoke: this.onOpenModal };

    return (
      <div>
        {isModalOpen && (
          <RevokeDelegationDialog
            isOpen
            closeModal={closeModal}
            eventHandler={this.onRevokeDelegation}
            employeeDelegated={modalEmployeeDelegated}
          />
        )}
        <h2>{intl.formatMessage(messages.delegation.employees.title)}</h2>
        <Card>
          <CardSection>
            <Toolbar>
              <ToolbarSection>
                <Button primary onClick={() => this.navigateAddDelegation()}>
                  {intl.formatMessage(messages.delegation.employees.addButton)}
                </Button>
              </ToolbarSection>
            </Toolbar>
            {isfetching && <Loader />}
            {!isfetching && isfetched && (
              <EmployeeDelegationTable employees={employees} action={action} />
            )}
          </CardSection>
        </Card>
      </div>
    );
  }
}

DelegationContainer.propTypes = {
  getDelegationList: PropTypes.func,
  delegation: PropTypes.object,
  push: PropTypes.func,
  isModalOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  modalEmployeeDelegated: PropTypes.object,
  revokeDelegation: PropTypes.func,
  setModalEmployeeDelegation: PropTypes.func,
  toggleModal: PropTypes.func,
  intl: intlShape.isRequired,
};

export default enhanceDelegationContainer(DelegationContainer);



// WEBPACK FOOTER //
// ./components/employee/delegation/DelegationContainer.js